module.exports = __webpack_public_path__ + "static/img/13.ca64167.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/4/eng/13.png
// module id = 4eQH
// module chunks = 0